import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import man from "../icons/concierge.svg";
import wand from "../icons/magic-wand-sparkles.svg";
import paper from "../icons/pencil-paper.svg";
import dollarSign from "../icons/dollar-sign.svg";
import reward from "../icons/reward.svg";
import notification from "../icons/notification.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import Title from "./Title";
import SubText from "./SubText";
import InfoBox from "./InfoBox";

const InfoBottom = ({ content }) => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: { xs: "0 2%", sm: "0 2%", md: "0 2%", lg: "0" },
        marginTop: "0%",
      }}
      mb={{ xs: "10%", sm: "10%", md: "5%", lg: "3%" }}
    >
      <SubText text={content?.details?.title} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          },
          margin: { xs: "0 12%", sm: "0 12%", md: "0 12%", lg: "0 2%" },
        }}
      >
        <InfoBox
          content={content?.details?.boxContent?.boxContent1}
          image={reward}
        />
        <InfoBox
          content={content?.details?.boxContent?.boxContent2}
          image={notification}
        />
        <InfoBox
          content={content?.details?.boxContent?.boxContent3}
          image={wand}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          },
          margin: { xs: "0 12%", sm: "0 12%", md: "0 12%", lg: "0 2%" },
        }}
      >
        <InfoBox
          content={content?.details?.boxContent?.boxContent4}
          image={dollarSign}
        />
        <InfoBox
          content={content?.details?.boxContent?.boxContent5}
          image={man}
        />
      </Box>
    </Box>
  );
};

export default InfoBottom;
